// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"0415218e","703":"28b91146"}[chunkId] + ".chunk.js";
};